// removed by extract-text-webpack-plugin
module.exports = {"iconChecked":"_2GI1EE9eYWQPe3Q11vmJBr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/About/About.css
// module id = 31
// module chunks = 0